import { render, staticRenderFns } from "./RoomSidebarSection.vue?vue&type=template&id=374ddee3&"
import script from "./RoomSidebarSection.vue?vue&type=script&lang=ts&"
export * from "./RoomSidebarSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports